<template>
    <div class="okraina-pci" @click="onClick">

        <div class="createdate">от {{ createdate }}</div>

        <div class="expire" v-if="expiredate">до {{ expiredate }}</div>

        <div class="title">{{ item.name }}</div>

        <div class="number">№ {{ item.numberfield }}</div>

    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "okraina-coupon-item",
    emits: ["click"],
    components: {
    },
    data() {
        return {
        };
    },
    props: {
        item: {
            type: Object,
            default() {
                return null;
            },
        },

    },

    computed: {
        createdate() {
            return moment(this.item.createdate, 'DD.MM.YYYY HH:mm:ss').format("DD MMMM YYYY");
        },

        expiredate() {
            if (!this.item.expirationdate) {
                return false;
            }

            return moment(this.item.expirationdate, 'DD.MM.YYYY HH:mm:ss').format("DD MMMM YYYY");
        }

    },

    methods: {

        /**
         * Обработка клика
         */
        onClick() {
            this.$emit("click");
        }
    }

}
</script>

<style lang="scss">
.okraina-pci {
    position: relative;
    margin-bottom: 10px;
    background-color: var(--color-block-background);
    border-radius: 8px;
    padding: 12px;
    cursor: pointer;

    .createdate {
        font-size: 12px;
        margin-bottom: 5px;
    }

    .title {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 5px;
    }

    .number {
        font-size: 12px;
    }

    .expire {
        position: absolute;
        top: 12px;
        right: 12px;
        background-color: #FFFF00;
        padding: 5px 8px;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 500;

    }
}
</style>